module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_RaggedRight",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.17em"
    }
  }, [_vm._v("Vous n’emmènerez ce bébé nulle part.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Lachlan claqua les mains sur la table et se leva.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Vous ne me connaissez pas, de toute évidence. Je ne renoncerai pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Oui, c’est bien le problème. Nous ne vous connaissons pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Imbécile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Je. Veux. Voir. Ma. Nièce.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Chaque mot fut prononcé d’une voix traînante et dans le ton le plus offensif qu’Holden puisse imaginer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— Elle est tout ce qu’il me reste de ma sœur, que je sois damné si je la laisse grandir avec une bande de types dans un cirque itinérant ringard.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Holden ne s’embêta pas à monologuer. Il avait appris toutes ses leçons de son père, et celle-ci était importante : si vous êtes sur le point de vous battre, ne discutez pas. Frappez en premier. Holden s’avança et cogna l’enfoiré juste sous la mâchoire, ce qui fit trébucher Lachlan en arrière.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("Le père d’Holden ouvrit la porte de la cuisine sans un mot et le coup de poing envoya Lachlan sur le perron près des marches. Le grand homme tenta de se reprendre pour se jeter sur lui, mais le mec faisait trois fois sa taille, alors ça n’allait pas fonctionner. Holden le frappa à nouveau et le trou du cul fut poussé en bas des marches, ponctuant les choses avec un bon coup de pied au cul.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("— T’es dans la merde, mec, dit-il en insistant sur le dernier mot, le rendant aussi méchant que possible. La prochaine fois, on frappera en premier et on posera les questions ensuite.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0